<template>
  <div class="legal-footer-links" :class="{ 'legal-footer-links--light': variant === 'light' }">
    <a href="https://solvea-advisory.com/impressum" target="_blank" rel="noopener noreferrer">
      {{ language === 'EN' ? 'Legal Notice' : 'Impressum' }}
    </a>
    <router-link :to="{ name: 'privacy-policy' }">
      {{ language === 'EN' ? 'Privacy Policy' : 'Datenschutz' }}
    </router-link>
    <router-link :to="{ name: 'disclaimer' }">
      {{ language === 'EN' ? 'Legal Disclaimer' : 'Rechtlicher Hinweis' }}
    </router-link>
  </div>
</template>

<script setup>
defineProps({
  language: { type: String, default: 'DE' },
  // 'light' fuer dunkle Hintergruende (z.B. Login-/Register-Seite, navy
  // .login-bg) - Default-Farben sind sonst auf dunklem Grund kaum lesbar.
  variant: { type: String, default: 'default' },
})
</script>

<style scoped>
.legal-footer-links {
  font-size: 12px;
  color: #9ca3af;
  display: flex;
  flex-wrap: wrap;
  gap: 8px 24px;
}

.legal-footer-links a {
  color: #6b7280;
  text-decoration: none;
}
.legal-footer-links a:hover {
  text-decoration: underline;
}

.legal-footer-links--light {
  color: rgba(255, 255, 255, 0.6);
  justify-content: center;
}
.legal-footer-links--light a {
  color: rgba(255, 255, 255, 0.85);
}
</style>
